"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCheckoutConfiguration = void 0;
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _getIsFlatSelectionUiFeatureToggle = require("./getIsFlatSelectionUiFeatureToggle");
const fetchCheckoutConfiguration = async ({
  globalApiUrl,
  language,
  staticApiUrl,
  tenant,
  token
}) => {
  const globalApiClient = new _globalApiClientReact.ApiClient({
    baseUrl: globalApiUrl,
    language,
    tenant,
    token
  });
  const staticApiClient = new _staticApiClientReact.ApiClient({
    baseUrl: staticApiUrl,
    language,
    tenant
  });
  const [{
    data: addressFormat
  }, {
    data: shoppingBagConfiguration
  }, isFlatSelection] = await Promise.all([(0, _globalApiClientReact.getAddressFormat)(globalApiClient, 'MultiLine', {
    [_fetching.TENANT_CONTEXT]: tenant
  }), (0, _staticApiClientReact.getTenantApplicationsShoppingBagConfiguration)(staticApiClient, tenant), (0, _getIsFlatSelectionUiFeatureToggle.getIsFlatSelectionUiFeatureToggle)({
    language,
    staticApiUrl,
    tenant
  })]);
  return {
    ...shoppingBagConfiguration,
    addressFormat,
    customerOrdersUrl: shoppingBagConfiguration.customerOrdersUrl,
    isBackorderExplicit: shoppingBagConfiguration.isBackorderExplicit,
    isFlatSelection,
    // applied only for simplified checkout
    isOrderReviewSkipped: shoppingBagConfiguration.isOrderReviewSkipped,
    manageSubscriptionUrl: shoppingBagConfiguration.manageSubscriptionUrl,
    rewardsShopUrl: shoppingBagConfiguration.rewardsShopUrl,
    maxBpQuantity: shoppingBagConfiguration.maxBpQuantity,
    maxQuantity: shoppingBagConfiguration.maxQuantity
  };
};
exports.fetchCheckoutConfiguration = fetchCheckoutConfiguration;